export const PLANNER_PANE_MIN_WIDTH_PX = 320;
export const PLANNER_PANE_MAX_WIDTH_VW = 0.5;

export const CUSTOM_ROUTE_DESKTOP_MAP = {
  map: 'map',
  more: 'more',
  save_recommended_route_tech_mode: 'save_recommended_route_tech_mode',
} as const;